<template>
  <div>
        <h3 class="my-3 vendor-heading">Vendor Materials</h3>
        <label class="vendor-tier-pricing-label">
          Add materials that this vendor can supply with pricing and lead time
        </label>
  <div class="materials-container " data-validation="materials-container">
    <div class="materials-empty errorbox mt-2" v-if="materialsTierdPricingData.length === 0">
      <svg class="materials-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 16V8C21 7.45 20.55 7 20 7H12L10 5H4C3.45 5 3 5.45 3 6V18C3 18.55 3.45 19 4 19H20C20.55 19 21 18.55 21 18V16Z"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 8L10 10L8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M3 8H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <p class="materials-text err-text">No materials added yet</p>

      <p class="materials-instruction">
        Click "Add Materials" to select materials this vendor can supply
      </p>
    </div>
    <div  v-else v-for="(material, index) in materialsTierdPricingData"
      :key="material.material_id">
    <div class="materials-container-box my-2" v-if="material.flag !== 'delete'">
      <div class="materials-container-heading">
        <div class="material">
          <span class="material-icon">
            <svg viewBox="0 0 24 24" id="Artwork" xmlns="http://www.w3.org/2000/svg" fill="#000000">
              <g id="SVGRepo_iconCarrier" stroke="none" stroke-width="0">
                <rect x="10.75" y="10.61" width="2.57" height="2.57" transform="translate(-4.89 12) rotate(-45.01)"
                  style="fill:#f452d6"></rect>
                <polygon
                  points="17.87 11.89 17.8 11.95 14.03 15.73 12.97 14.68 15.77 11.89 10.06 6.18 10.06 4.08 10.13 4.15 17.87 11.89"
                  style="fill:#f452d6;fill-rule:evenodd"></polygon>
                <polygon points="10.06 6.18 4.36 11.89 11.11 18.65 10.06 19.7 10 19.63 2.25 11.89 10.06 4.08 10.06 6.18"
                  style="fill:#f452d6;fill-rule:evenodd"></polygon>
                <polygon points="13.94 17.6 13.94 19.7 13.88 19.63 6.13 11.9 9.97 8.05 11.03 9.11 8.23 11.9 13.94 17.6"
                  style="fill:#f452d6;fill-rule:evenodd"></polygon>
                <polygon
                  points="13.94 17.6 19.64 11.9 12.89 5.14 13.94 4.08 14 4.15 21.75 11.9 21.68 11.96 13.94 19.7 13.94 17.6"
                  style="fill:#f452d6"></polygon>
              </g>
            </svg> </span>
          <div class="material-name-box">
            <h3 class="material-name">{{ material.material_name }}</h3>
            <p class="material-id">{{ material.custom_material_id }}</p>
          </div>
        </div>
        <div class="delete-icon">
          <img src="~@/assets/images/delete-icon.svg" v-tooltip="'Remove Material'" alt=""
            @click="removeMaterial(index)" />
        </div>
      </div>
      <div class="grid-2 mb-2">
        <div :data-validation="`leadTime-${material.material_id}`" class="input-group imp">
          <label>Lead Time (days)</label>
          <input placeholder="Enter lead time " min="1" type="number" :disabled="isUrl" :style="isUrl ? disabledStyle : null"
            v-model="material.lead_time" @blur="update({materailId:material.material_id,field:'lead_time',index})" />
        </div>
        <div :data-validation="`moq-${material.material_id}`" class="input-group imp">
          <label>MOQ</label>
          <input placeholder="Enter Quantity " min="1" type="number" :disabled="isUrl" :style="isUrl ? disabledStyle : null"
            v-model="material.moq" @blur="update({materailId:material.material_id,field:'moq',index})" />
        </div>
      </div>

      <h5 class="tiered-pricing-heading mb-2 mt-3">Tiered Pricing</h5>
      <div :class="['tiered-pricing-container', { 'show-tpc-border': material.tier_pricing.length > 0 }]">
        <div class="mb-2">
          <div v-for="(pricing, tpIndex) in material.tier_pricing" :key="`tp-${material.material_id}-${tpIndex}`">
          <div class="grid-4" v-if="pricing.flag!=='delete'">
            <div :data-validation="`tp-${material.material_id}-${tpIndex}-minQty`" class="input-group imp">
              <label>Min Qty</label>
              <input placeholder="Enter Quantity " min="1" type="number" :disabled="isUrl" :style="isUrl ? disabledStyle : null"
                v-model="pricing.min_qty" @blur="update({materailId:material.material_id,field:'min_qty',index, tpIndex})" />
            </div>
            <div :data-validation="`tp-${material.material_id}-${tpIndex}-maxQty`" class="input-group imp">
              <label>Max Qty</label>
              <input placeholder="Enter Quantity " min="1" type="number" :disabled="isUrl" :style="isUrl ? disabledStyle : null"
                v-model="pricing.max_qty"  @blur="update({materailId:material.material_id,field:'max_qty',index, tpIndex})" />
            </div>
            <div :data-validation="`tp-${material.material_id}-${tpIndex}-unitPrice`" class="input-group imp">
              <label>Price (₹/Unit)</label>
              <input placeholder="Enter Price " min="1" type="number" :disabled="isUrl" :style="isUrl ? disabledStyle : null"
                v-model="pricing.unit_cost"  @blur="update({materailId:material.material_id,field:'unit_cost',index, tpIndex})" />
            </div>
            <div class="delete-tier">
              <img src="~@/assets/images/delete-icon.svg" v-tooltip="'Remove Price Tier'" alt=""
                @click="removeTiredPricingRow(index, tpIndex)" />
            </div>
          </div>
          </div>
          <button class="add-price-tier-btn mt-3" @click="addTiredPricingRow(index)">+ Add Price Tier</button>
        </div>

      </div>
    </div>
    </div>
    <button class="materials-add-btn" @click="openMaterialModal">+ Add Materials</button>
    <modal title="Select Materials" :open="addMaterialModal" @close="addMaterialModal = false"
      :closeOnOutsideClick="true"
      >
      <material-selector :selectedMaterials="Array.from(this.selectedMaterialsMap.values())" :formTypeId="null"
        :clear="clear" @toggle-selected="toggleToSelected" @remove-selected="toggleToSelected" :feature="'vendorMaterial'"
        @add-materials="addSelectedMaterials" @cancel="handleMaterialCancel" @clear-tags="clearTags" />

    </modal>
  </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Modal from '../common/modal.vue'
import MaterialSelector from '../materialMaster/materialSelector.vue'
import { alert } from '@/plugins/notification'
import { materialCheck } from '@/helper/formValidation/inviteTenant'
import { positiveFloat } from '@/helper/formValidation'

export default {
  name: 'VendorMaterialPricing',
  components: { Modal, MaterialSelector },
  props: {
    materials: {
      type: Array,
      required: true,
      default: () => []
    },
    isUrl: {
      type: Boolean,
      default: false
    },
    disabledStyle: {
      type: Object,
      default: () => ({
        backgroundColor: '#f0f0f0',
        color: '#a0a0a0'
      })
    }
  },
  data () {
    return {
      materialsTierdPricingData: [],
      selectedMaterialsMap: new Map(),
      addMaterialModal: false,
      clear: false
    }
  },
  computed: {
  },
  methods: {
    ...mapMutations('tag', ['clearAllTags']),
    addTiredPricingRow (index) {
      this.materialsTierdPricingData[index].tier_pricing.push({
        min_qty: '',
        max_qty: '',
        unit_cost: '',
        flag: 'new'
      })
    },
    resetForm () {
      this.selectedMaterialsMap = new Map()
      const temp = this.materialsTierdPricingData.map((material) => {
        if (material.flag !== 'exist') {
          material.flag = 'delete'
        }
        return material
      })
      this.materialsTierdPricingData = temp
    },
    handleMaterialCancel () {
      this.addMaterialModal = false
    },
    removeTiredPricingRow (materialIndex, tpIndex) {
      if (this.materialsTierdPricingData[materialIndex].tier_pricing.length <= 1) {
        alert('Minimum one tier price required')
        return
      } else {
        const availableTiers = this.materialsTierdPricingData[materialIndex].tier_pricing.filter(p => p.flag !== 'delete')
        if (availableTiers.length === 1) {
          alert('Minimum one tier price required')
          return
        }
      }
      if (this.materialsTierdPricingData[materialIndex].tier_pricing[tpIndex].flag === 'new') {
        this.materialsTierdPricingData[materialIndex].tier_pricing.splice(tpIndex, 1)
      } else {
        this.materialsTierdPricingData[materialIndex].tier_pricing[tpIndex].flag = 'delete'
      }
      this.materialsTierdPricingData = [...this.materialsTierdPricingData]
    },
    removeMaterial (materialIndex) {
      if (this.materialsTierdPricingData.length === 1) {
        alert('Minimum one material data required')
        return
      } else {
        const availableMaterials = this.materialsTierdPricingData.filter(item => item.flag !== 'delete')
        if (availableMaterials.length === 1) {
          alert('Minimum one material data required')
          return
        }
      }
      if (this.materialsTierdPricingData[materialIndex].flag === 'new') {
        this.materialsTierdPricingData.splice(materialIndex, 1)
      } else {
        this.materialsTierdPricingData[materialIndex].flag = 'delete'
      }
    },

    toggleToSelected (item) {
      const existingItem = this.selectedMaterialsMap.get(item.id)
      if (existingItem && existingItem?.flag === 'exist') {
        existingItem.flag = 'delete'
        this.selectedMaterialsMap.set(item.id, existingItem)
      } else if (existingItem && existingItem?.flag === 'new') {
        this.selectedMaterialsMap.delete(item.id)
      } else if (existingItem && existingItem?.flag === 'delete') {
        for (const material in this.materialsTierdPricingData) {
          if (this.materialsTierdPricingData[material].material_id === item.id) {
            this.selectedMaterialsMap.set(item.id, { ...this.materialsTierdPricingData[material], flag: 'exist' })
            break
          }
        }
      } else {
        let data = {
          material_id: item.id,
          custom_material_id: item.custom_material_id,
          material_name: item.material_name,
          moq: '',
          lead_time: '',
          tier_pricing: [{ min_qty: '', max_qty: '', unit_cost: '', flag: 'new' }],
          flag: 'new'
        }
        for (const material in this.materialsTierdPricingData) {
          if (this.materialsTierdPricingData[material].material_id === item.id) {
            data = this.materialsTierdPricingData[material]
            if (data.flag === 'delete') {
              data.flag = 'exist'
            }
            break
          }
        }
        this.selectedMaterialsMap.set(item.id, data)
      }
      this.selectedMaterialsMap = new Map(this.selectedMaterialsMap)
    },
    addSelectedMaterials () {
      this.clear = true
      this.clearTags()
      this.materialsTierdPricingData = Array.from(this.selectedMaterialsMap.values())
      this.addMaterialModal = false
      this.selectedMaterialsMap = new Map()
    },
    clearTags () {
      this.clear = true
      this.clearAllTags()
    },
    update ({ materailId, field, index, tpIndex }) {
      switch (field) {
      case 'lead_time':
      case 'moq': {
        if (field === 'moq') {
          positiveFloat(this.materialsTierdPricingData[index].moq, 'MOQ', `moq-${materailId}`, false, true)
        }
        if (field === 'lead_time') {
          positiveFloat(this.materialsTierdPricingData[index].lead_time, 'LeadTime', `leadTime-${materailId}`, false, true)
        }
        if (this.materialsTierdPricingData[index].flag === 'exist') {
          this.materialsTierdPricingData[index].flag = 'update'
        }
        break
      }
      case 'min_qty':
      case 'max_qty':
      case 'unit_cost':
      {
        const tierRow = this.materialsTierdPricingData[index].tier_pricing[tpIndex]
        let contentAvailableIndex = -1
        for (let i = 0; i < this.materialsTierdPricingData[index].tier_pricing.length; i++) {
          if (this.materialsTierdPricingData[index].tier_pricing[i]?.flag === 'delete') {
            continue
          }
          contentAvailableIndex = i
        }
        const minSel = `tp-${materailId}-${tpIndex}-minQty`
        const maxSel = `tp-${materailId}-${tpIndex}-maxQty`
        const priceSel = `tp-${materailId}-${tpIndex}-unitPrice`
        if (this.materialsTierdPricingData[index].flag !== 'new' && tierRow.flag === 'exist') {
          this.materialsTierdPricingData[index].tier_pricing[tpIndex].flag = 'update'
        }
        if (field === 'unit_cost') {
          positiveFloat(tierRow.unit_cost, 'Price', priceSel, false, true)
        }
        if (field === 'min_qty') {
          positiveFloat(tierRow.min_qty, 'Min qty', minSel, false, true)
          tierRow.max_qty && positiveFloat(tierRow.max_qty, 'Max qty', maxSel, false, true)
        }
        if (field === 'max_qty') { // for excluding last max qty row
          tpIndex !== contentAvailableIndex && positiveFloat(tierRow.max_qty, 'Max qty', maxSel, false, true)
          tierRow.min_qty && positiveFloat(tierRow.min_qty, 'Min qty', minSel, false, true)
        } else if (field === 'max_qty') {
          tierRow.min_qty && positiveFloat(tierRow.min_qty, 'Min qty', minSel, false, true)
        }
        if (tierRow.min_qty && tierRow.max_qty && (tierRow.max_qty ?? tpIndex !== contentAvailableIndex)) {
          if (tierRow.min_qty > tierRow.max_qty) {
            positiveFloat(null, 'Min qty', minSel, false, true, 'min qty should be less than max qty')
            positiveFloat(null, 'Max qty', maxSel, false, true, 'max qty should be greater than min qty')
          }
        }
      }
      }
      // const formatedPricingData = { approval_workflow: true, materials: this.materialsTierdPricingData }
      // materialCheck(formatedPricingData)
    },
    openMaterialModal () {
      this.selectedMaterialsMap = new Map()
      for (const material of this.materialsTierdPricingData) {
        if (material.flag !== 'delete') {
          this.selectedMaterialsMap.set(material.material_id, material)
        }
      }
      this.addMaterialModal = true
    },
    callValidation () {
      materialCheck(this.materialsTierdPricingData)
    }

  },
  mounted () {
    this.materialsTierdPricingData = this.materials
  }
}
</script>

<style lang="scss" scoped>
.vendor-tier-pricing-label {
  font-size: 1em;
  color: #374151;
}

.tiered-pricing-container {
  padding: 1rem;
  border-radius: 5px;
  margin-bottom: 1.5rem;

  & .add-price-tier-btn {
    width: 100%;
    padding: 5px;
    border: none;
    background: transparent;
    color: #374151;
    font-size: var(--text-base);
    cursor: pointer;
    transition: background-color 0.3s;
    border-radius: 5px;
    border: 1px solid #d1d5db80;
    margin-top:25px;
    &:hover {
      background-color: var(--brand-light-color);
      border-color: var(--brand-color);
      transform: translateY(-1px);
      transition: transform 0.2s ease;
    }
  }

  & .delete-tier {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 8px 5px;
    align-self: flex-emd;

    & img {
      width: 16px;
      height: 16px;
    }

    &:hover {
      background-color: #f8d7d773;
      border-radius: 5px;
    }
  }
}

.materials {
  &-container {
    & .show-tpc-border {
      border: 1px solid #dee2e8d9;
    }

    & .grid-4 {
      display: grid;
      grid-template-columns: 5fr 5fr 5fr 1fr;
      gap: 1rem;
      /* adjust as per your current spacing, e.g., 16px or 1.5rem */
      align-items: flex-end;
    }

    & .material {
      grid-column: span 4;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      gap: 10px;

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px;
        border-radius: 5px;
        background-color: #faf5ff;

        & svg {
          width: 24px;
          height: 24px;
        }
      }

      &-name-box {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-left: 1rem;
      }

      &-name {
        font-size: 1rem;
        font-weight: 500;
      }

      &-id {
        font-size: 0.8rem;
        color: #6b7280;
      }
    }

    &-heading {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    & .delete-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 8px 5px;
      align-self: start;

      & img {
        width: 16px;
        height: 16px;
      }

      &:hover {
        background-color: #f8d7d773;
        border-radius: 5px;
      }
    }

    &-box {
      border: 1px solid rgb(222 226 232 / 45%);
      box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
      border-radius: 5px;
      padding: 1rem;
    }

    & .tiered-pricing-heading {
      font-size: 1rem;
      font-weight: 400;
    }
  }

  &-empty {
    background-color: #ffffff;
    border: 1px dashed #e5e7eb;
    border-radius: 8px;
    padding: 48px 24px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &-icon {
    width: 64px;
    height: 64px;
    color: #c7ccd5;
    margin-bottom: 16px;
  }

  &-text {
    font-size: var(--text-base);
    font-weight: 400;
    color: #4b5563;
    margin: 0 0 12px 0;
  }

  &-instruction {
    font-size: var(--text-s);
    color: #6b7280;
    /* background-color: #f3f4f6; */
    padding: 8px 16px;
    border-radius: 4px;
    margin: 0;
  }

  &-add-btn {
    width: 100%;
    padding: 10px;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: background-color 0.3s;
    border-radius: 5px;
    border: 1px solid var(--brand-color);
    margin-block: 1rem;

    &:hover {
      background-color: var(--brand-light-color);
      border-color: var(--brand-color);
      color: black;
      transform: translateY(-1px);
      transition: transform 0.2s ease;
    }
  }
}

.material-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.material-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 18px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  transition: 0.2s ease;
  min-width: 400px;
  margin-bottom: 5px;

  &:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }

  .icon {
    width: 26px;
    height: 26px;
    border-radius: 6px;
  }

  .details {
    h4 {
      margin: 0;
      font-size: var(--text-l);
      font-weight: 500;
      color: #111827;
    }

    p {
      margin: 7px 0 0;
      font-size: var(--text-s);
      color: #6b7280;
    }
  }
}

.material-select-btn-grp {
  display: flex;
  justify-content: end;
  gap: 10px;
  position: sticky;
  bottom: 0px;
  background-color: var(--bg-color);
  padding: 10px;
  width: 100%;
}
.vendor-heading{
    font-weight: 500;
    font-size: var(--text-l);
}
</style>
